import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/alertsSlice";
import { toast } from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  TimePicker,
  message,
  Card,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import Layout from "../../components/layout";


const { Option } = Select;

function AdminScheduleDoctor() {
  const [services, setServices] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState([]);
  const [locations, setLocations] = useState([]);
  const [specialitys, setSpecialitys] = useState([]);
  const [totalSlots, setTotalSlots] = useState([]);

  const format = "HH:mm";
  const [clinicDays, setClinicDays] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [form] = Form.useForm();

  const formatTimings = (appointmentTime) => {
    return appointmentTime.map((time) => time.format("HH:mm"));
  };

  // Fetch clinic days
  useEffect(() => {
    axios
      .get("/api/user/get-all-clinic-day")
      .then((res) => {
        if (res.data.success) {
          setClinicDays(res.data.clinicDays);
        } else {
          message.error("Failed to load clinic days");
        }
      })
      .catch(() => {
        message.error("Error fetching clinic days");
      });
  }, []);

  // Fetch doctors
  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        dispatch(showLoading());
        const response = await axios.get("/api/admin/get-registered-doctors", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        dispatch(hideLoading());

        if (response.data.success) {
          setDoctors(response.data.data);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        dispatch(hideLoading());
        toast.error("Failed to fetch doctors");
      }
    };

    fetchDoctors();
  }, [dispatch]);

  // Fetch locations
  useEffect(() => {
    const getLocationData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-location", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setLocations(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getLocationData();
  }, []);

  // Fetch speciality
  useEffect(() => {
    const getSpecialityData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-speciality", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setSpecialitys(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getSpecialityData();
  }, []);

  // Fetch total slots
  useEffect(() => {
    const getTotalSlotsData = async () => {
      try {
        const response = await axios.get(
          "/api/Appointmentslot/get-all-totalSlots",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.data.success) {
          setTotalSlots(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getTotalSlotsData();
  }, []);

  // Fetch services
  useEffect(() => {
    const getServiceData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-services", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setServices(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getServiceData();
  }, []);

  const onFinish = async (values) => {
    if (selectedDays.length === 0) {
      message.error("Please select at least one clinic day.");
      return;
    }

    try {
      dispatch(showLoading());

      const formattedTimings = formatTimings(values.appointmentTime);

      const requestData = {
        ...values,
        clinicDays: selectedDays.join(", "),
        appointmentTime: formattedTimings,
      };

      const response = await axios.post(
        "/api/admin/admin-apply-appointment",
        requestData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(hideLoading());

      if (response.data.success) {
        toast.success("Doctor appointment scheduled successfully");
        setSelectedDays([]);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  const validateTiming = (rule, value) => {
    if (
      value &&
      value[0] &&
      value[1] &&
      value[0].format(format) !== "00:00" &&
      value[1].format(format) !== "00:00"
    ) {
      return Promise.resolve();
    }
    return Promise.reject("Please select valid time of appointment");
  };

  // Handle doctor selection → populate form
  const handleDoctorChange = (doctorId) => {
    const doc = doctors.find((d) => d._id === doctorId);
   

    if (doc) {
      // If backend provides firstName/lastName use them; otherwise split name
      const firstName = doc.firstName || (doc.name ? doc.name.split(" ")[0] : "");
      const lastName =
        doc.lastName ||
        (doc.name ? doc.name.split(" ").slice(1).join(" ") : "");

      form.setFieldsValue({
        firstName,
        lastName,
        email: doc.email || "",
        phoneNumber: doc.phone || "",
      });
    }
  };

  return (
    <Layout>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Card
          title="Create Schedule Doctor"
          bordered={false}
          style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
        >
          <Form
            form={form}
            layout="vertical"
            className="formFactor"
            onFinish={onFinish}
          >
            {/* Service & Doctor selection */}
            <Row gutter={20}>
              <Col span={24}>
                <Form.Item
                  label="Select Specialty"
                  name="service"
                  rules={[{
                    required: true,
                    message: "Please select an Appointment Service!",
                  }]}
                >
                  <Select placeholder="Select a service">
                    {services.map((service) => (
                      <Option key={service.service} value={service.service}>
                        {service.service}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Select Doctor"
                  name="doctor"
                  rules={[{ required: true, message: "Please select a doctor!" }]}
                >
                  <Select
                    placeholder="Select a doctor"
                    onChange={handleDoctorChange}
                  >
                    {doctors.map((doctor) => (
                      <Option key={doctor._id} value={doctor._id}>
                        {doctor.name || `${doctor.firstName} ${doctor.lastName}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Doctor Information */}
            <h3 className="card-title mv page-box-minimal">Doctor Information</h3>
            <Row gutter={20}>
              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Doctor First Name"
                  name="firstName"
                  rules={[{ required: true, message: "Please enter first name!" }]}
                >
                  <Input placeholder="First Name" suffix={<EditOutlined />} />
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Doctor Last Name"
                  name="lastName"
                  rules={[{ required: true, message: "Please enter last name!" }]}
                >
                  <Input placeholder="Last Name" suffix={<EditOutlined />} />
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Doctor Email"
                  name="email"
                  rules={[{ required: true, message: "Please enter a valid email!" }]}
                >
                  <Input placeholder="Email Address" readOnly />
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Doctor Phone Number"
                  name="phoneNumber"
                  rules={[{
                    required: true,
                    message: "Please enter a phone number!",
                  }]}
                >
                  <Input placeholder="Phone Number" readOnly />
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Appointment Location"
                  name="location"
                  rules={[{ required: true, message: "Please select a location!" }]}
                >
                  <Select placeholder="Select a location">
                    {locations.map((location) => (
                      <Option key={location.location} value={location.location}>
                        {location.location}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Appointment Slots"
                  name="totalSlots"
                  rules={[{
                    required: true,
                    message: "Please select appointment slot!",
                  }]}
                >
                  <Select placeholder="Select slots">
                    {totalSlots.map((slot) => (
                      <Option key={slot.totalSlots} value={slot.totalSlots}>
                        {slot.totalSlots}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Professional Information */}
            <h3 className="card-title mt-3 mv page-box-minimal">Professional Information</h3>
            <Row gutter={20}>
              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Specialization"
                  name="specialization"
                  rules={[{
                    required: true,
                    message: "Please select doctor specialization!",
                  }]}
                >
                  <Select placeholder="Select a specialization">
                    {specialitys.map((speciality) => (
                      <Option key={speciality.speciality} value={speciality.speciality}>
                        {speciality.speciality}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Experience"
                  name="experience"
                  rules={[{ required: true, message: "Enter experience!" }]}
                >
                  <Input placeholder="Experience" type="number" />
                </Form.Item>
              </Col>

              <Col span={8} xs={24} sm={24} lg={8}>
                <Form.Item
                  required
                  label="Consultation Fee"
                  name="feePerConsultation"
                  rules={[{
                    required: true,
                    message: "Enter consultation fee!",
                  }]}
                >
                  <Input placeholder="Consultation Fee" type="number" />
                </Form.Item>
              </Col>

              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  required
                  label="Appointment Timing"
                  name="appointmentTime"
                  rules={[{ validator: validateTiming }]}
                >
                  <TimePicker.RangePicker format="HH:mm" className="mt-3" />
                </Form.Item>
              </Col>

              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  label="Choose Clinic Days"
                  name="clinicDay"
                  rules={[{ required: true, message: "Select clinic day(s)!" }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Select clinic days"
                    value={selectedDays}
                    onChange={setSelectedDays}
                    style={{ width: "100%" }}
                    dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                    className="mt-3"
                  >
                    {clinicDays.map((day) => (
                      <Option key={day.name} value={day.name}>
                        {day.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Submit Button */}
            <Form.Item>
              <Button type="primary" className="btn-primary" htmlType="submit">
                Schedule Appointment
              </Button>
            </Form.Item>
          </Form>

        </Card>
      </div>
    </Layout>
  );
}

export default AdminScheduleDoctor;